const config = {
  id: "7e8d9a560b690317bf71",
  secret: "02ed7755cdbfb43ddaa382731c70d17f68f149a2"
}

module.exports = config




// WEBPACK FOOTER //
// ./config/config.js